import AppDispatcher from '../utils/AppDispatcher';

import AjaxPromises from '../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../constants/GuestConstants';
import { actions as ActionTypes } from '../constants/GuestListConstants';
import { actions as CartActions } from '../constants/PosCartConstants';
import GuestListApi from '../api/GuestListApi';

import NotificationActions from './NotificationActions';
import RoutingActions from './RoutingActions';

import UserStore from '../stores/UserStore';
import GuestListStore from '../stores/GuestListStore';
import PopupStore from '../stores/PopupStore';

import * as _ from 'lodash';

var GuestListActions = {
    loadGuestList:(notification, showError = true) => {
        var promise = GuestListApi.loadGuestList(UserStore.getApiData());
        promise.then(res => {

            if (!res.Result && showError) {
                setTimeout(() => {
                    NotificationActions.addNotification({
                        type : 'error',
                        body : res.Message,
                    });
                }, 100);
            }

            if (notification && res.Result)
                NotificationActions.success('Guest List Refreshed');

            var tmp;
            if (res.Data) {
                for (var i=0; i<res.Data.length; i++) {

                    tmp = res.Data[i].FullName.split(' ');
                    res.Data[i].FirstName = tmp[0].toLowerCase();

                    res.Data[i].LastName = tmp.length > 1 ? tmp[tmp.length-1].toLowerCase() : tmp[0].toLowerCase();
                }
            }

            AppDispatcher.dispatch({
                actionType: ActionTypes.GUEST_LIST_LOADED,
                data: res.Data ? res.Data : []
            });
        });
        return promise;
    },
    addOrUpdateGuest: (guestUpdated) => {
        const guestList = GuestListStore.getState().guestList;
        const guestFound = guestList.find(guest => guest.Guest_id === guestUpdated.Guest_id && guest.ShipmentId === guestUpdated.ShipmentId);
        if(guestFound && guestUpdated && guestUpdated.ShipmentId){
            if(guestUpdated.TransactionStatus){
                guestFound.TransactionStatus = guestUpdated.TransactionStatus;
            }
            if(guestUpdated.Room){
                guestFound.Room = guestUpdated.Room;
            }
            if(guestUpdated.RegisterId){
                guestFound.Register = guestUpdated.Register;
                guestFound.RegisterId = guestUpdated.RegisterId;
            }
            if(guestUpdated.ShipmentId){
                guestFound.RegisterId = guestUpdated.RegisterId;
                guestFound.ShipmentId = guestUpdated.ShipmentId,
                guestFound.ScheduleId = guestUpdated.ScheduleId
            }
            if(guestUpdated.FullName){
                guestFound.FullName = guestUpdated.FullName;
            }
            if(guestUpdated.IsLoyaltyMember){
                guestFound.IsLoyaltyMember = guestUpdated.IsLoyaltyMember;
            }
            if(guestUpdated.MJStateIDNo){
                guestFound.MJStateIDNo = guestUpdated.MJStateIDNo;
            }
            if(guestUpdated.PatientType){
                guestFound.PatientType = guestUpdated.PatientType;
            }
            if(guestUpdated.TotalItems || guestUpdated.TotalItems === 0){
                guestFound.TotalItems = guestUpdated.TotalItems;
            }
            if(guestUpdated.nickname){
                guestFound.nickname = guestUpdated.nickname;
            }
            if(guestUpdated.TransactionReference){
                guestFound.TransactionReference = guestUpdated.TransactionReference;
            }
        }else{
            if(guestUpdated && guestUpdated.ShipmentId){
                guestList.push(guestUpdated);
            }
        }
        AppDispatcher.dispatch({
            actionType: ActionTypes.GUEST_LIST_LOADED,
            data: guestList
        });
    },
    removeGuest: (guestId) => {
        const guestList = GuestListStore.getState().guestList;
        const guestIndexFound = guestList.findIndex(guest => guest.Guest_id === guestId);
        if(guestIndexFound > -1){
            guestList.splice(guestIndexFound, 1);        
        }
        AppDispatcher.dispatch({
            actionType: ActionTypes.GUEST_LIST_LOADED,
            data: guestList
        });
    },
    removeGuestByTransactionId: (transactionId) => {
        const guestList = GuestListStore.getState().guestList;
        const guestIndexFound = guestList.findIndex(guest => guest.ShipmentId === transactionId.toString());
        if(guestIndexFound > -1){
            guestList.splice(guestIndexFound, 1);        
        }
        AppDispatcher.dispatch({
            actionType: ActionTypes.GUEST_LIST_LOADED,
            data: guestList
        });
    },

    notifyPusherConnected: () => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GUEST_NOTIFICATION_GROUP_JOINED,
            data: {}
        });
    },

    authPusherChannel: (socketId) => {
        var formData = UserStore.getApiData();
        formData.SocketId = socketId;
        return GuestListApi.authPusherChannel(formData);
    },
    getPusherConfiguration: () => {
        var formData = UserStore.getApiData();
        return GuestListApi.getPusherConfig(formData);
    },
    notifyConnectionLost: () => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.NOTIFY_CONNECTION_LOST,
            data: {}
        });   
    },
    search:(query) => {
        var formData = UserStore.getApiData();
        formData.SearchString = query;

        AppDispatcher.dispatch({
            actionType: ActionTypes.SEARCH_RESULTS,
            data: []
        });

        var promise = GuestListApi.search(formData);

        promise.then(res => {
            if (!res.Result) {
                setTimeout(() => {
                    NotificationActions.addNotification({
                        type : 'success',
                        body : res.Message,
                        timer : false,
                        sticky : false
                    });
                }, 100);

                AppDispatcher.dispatch({
                    actionType: ActionTypes.SEARCH_RESULTS,
                    data: []
                });
            } else {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.SEARCH_RESULTS,
                    data: res.Data
                });
            }
        });
    },

    scan: (barcode) => {
        var data = UserStore.getApiData({ barcode: barcode });
        GuestListApi.scan(data).then(resp => {
            if(!resp.Result) {
                NotificationActions.error('Error scanning barcode');
                return;
            }
            var data = resp.Data;
            switch (data.Type.toLowerCase()) {
                case 'none':
                    NotificationActions.alert('Scan not found');
                    break;
                case 'guest':
                    GuestListActions.checkGuestIn({ MJStateIDNo: barcode, shipmentId: '' })
                    break;
                case 'transaction':
                    var registerId = UserStore.getState().selectedRegister.id;
                    if (!registerId) {
                        NotificationActions.warn('No register selected');
                        return;
                    }
                    var guest = _.find(GuestListStore.getState().guestList, g => g.Guest_id === parseInt(data.Id));

                    if (!guest) {
                        NotificationActions.warn('Guest is not checked in');
                        return;
                    }

                    var guestRegister = parseInt(guest.RegisterId);

                    if (!!guestRegister && guestRegister !== registerId) {
                        NotificationActions.warn('Guest is already assigned to register ' + guest.Register);
                        return;
                    }
                    GuestListActions.selectGuestForPos(guest).then(() => {
                        RoutingActions.updateRoute('pos/' + data.Id);
                    });
                    break;
                /*case 'transactionhistory':
                    let guest = GuestListActions.getGuest(data.Id);

                    if (!!guest) {
                        GuestListStore.setGuest(guest);
                        GuestListStore.setTransactionId(parseInt(data.TransactionId));
                        GuestListStore.setPage('scanTransaction');
                    }

                    break; */
            }
        });
    },

    getGuest: async (guestId) => {
        await AjaxPromises.POST('api/customers/get-customer', UserStore.getApiData({
            CustomerId: guestId
        })).then(res => {
            if (!!res.Data) {
                return res.Data;
            }
        });
    },

    checkGuestInCaregiver:(guest, CaregiverMJStateIdNo, toPOS) => {
        var formData = UserStore.getApiData({
            MJStateIDNo: guest.MJStateIDNo,
            shipmentId: guest.ShipmentId,
            AcctId: guest.Guest_id,
            CaregiverMJStateIdNo: CaregiverMJStateIdNo,
            RoomId: UserStore.getRoomId() || 0
        });

        return GuestListActions.checkGuestInFormData(formData, toPOS);
    },

    checkGuestIn:(guest, toPOS) => {
        var formData = UserStore.getApiData({
            MJStateIDNo: guest.MJStateIDNo,
            shipmentId: guest.ShipmentId,
            AcctId: guest.Guest_id,
            RoomId: UserStore.getRoomId() || 0
        });

        return GuestListActions.checkGuestInFormData(formData, toPOS);
    },

    checkGuestInFormData:(formData, toPOS) => {
        return (!!toPOS ?
            GuestListApi.checkGuestInToPOS(formData) :
            GuestListApi.checkGuestIn(formData)
        )
        .then(res => {
            if (!res.Result || res.Data[0].ScanId === 0) {
                NotificationActions.error(res.Data ? res.Data[0].ScanResult : res.Message);
            } 
            else {
                NotificationActions.addNotification({
                    type : 'success',
                    body : res.Message,
                    fullscreen : UserStore.getState().selectedLocation.UseBioTrackPOS,
                    sticky : UserStore.getState().selectedLocation.UseBioTrackPOS,
                });
                return res;
            }
        });
    },

    checkGuestOut:(guest, cancelReason = '') => {
        var formData        = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;
        formData.Guest_id   = guest.Guest_id.toString();
        formData.ScheduleId = guest.ScheduleId;
        formData.CancelReason = cancelReason;

        var promise = GuestListApi.checkGuestOut(formData);

        promise.then(res => {

            setTimeout(() => {
                NotificationActions.addNotification({
                    type   : res.Result ? 'success' : 'error',
                    body   : (res.Data && res.Data[0] && res.Data[0].hasOwnProperty('Column1')) ? res.Data[0].Column1 : res.Message
                });
            }, 100);
            if(!UserStore.getState().selectedLocation.UseSmartCheckin){
                GuestListActions.loadGuestList();
            }
        });
    },

    selectGuestForPos(guest) {
        var formData            = UserStore.getApiData();
        formData.Guest_id       = guest.Guest_id;
        formData.ShipmentId     = guest.ShipmentId;
        formData.RegisterId     = UserStore.getState().selectedRegister.id;
        formData.ScheduleId     = guest.ScheduleId;

        var promise = GuestListApi.selectGuestForPos(formData);

        return promise.then(res => {
            if(UserStore.getState().selectedLocation.UseSmartCheckin){
                GuestListActions.addOrUpdateGuest({
                    Guest_id: formData.Guest_id,
                    ShipmentId: formData.ShipmentId,
                    RegisterId: formData.RegisterId,
                    ScheduleId: formData.ScheduleId
                });
            }
            if (res.Result) {
                if (res.Data[0].Results !== 'Patient Has not completed the Attestation Document. You cannot Proceed.') {
                    if (UserStore.getState().selectedLocation.UseBioTrackPOS) {
                        var formData = UserStore.getApiData();
                        formData.PatientScan = guest.MJStateIDNo;
                        formData.ShipmentId = guest.ShipmentId;

                        promise = GuestListApi.biotrackScanGuestIn(formData);

                        promise.then(res => {
                            GuestListActions.loadGuestList();
                        });
                    } else if(UserStore.getState().selectedLocation.UseMn) {
                        PopupStore.emitChange({ page : 'select-collector', guest: guest });
                        GuestListActions.loadGuestList();//??
                    }
                    else {
                        GuestListActions.loadGuestList();
                    }
                } else {
                    setTimeout(() => {
                        NotificationActions.error('Patient Has not completed the Attestation Document. You cannot Proceed.');
                    }, 100);
                }
            } else {
                setTimeout(() => {
                    NotificationActions.addNotification({
                        type   : 'error',
                        body   : res.Message
                    });
                }, 100);
            }
        });
    },

    releaseGuestFromPos(formData) {
        var promise = GuestListApi.releaseGuestFromPos(formData);

        promise.then(res => {

            if (res.Result) {
                if(UserStore.getState().selectedLocation.UseSmartCheckin){
                    GuestListActions.addOrUpdateGuest({
                        Guest_id: formData.Guest_id,
                        Register: '',
                        RegisterId: '0'
                    })
                }else{
                    GuestListActions.loadGuestList();
                }
                GuestListStore.setPage('list');
                RoutingActions.updateRoute('guest-list');                
            } else {
                setTimeout(() => {
                    NotificationActions.addNotification({
                        type   : 'error',
                        body   : res.Message
                    });
                }, 100);
            }
        });
    },

    toggleSearchBar(val) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_SEARCH_BAR,
            data: val
        });
    },

    toggleGuestAssignedToRegister(val) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_GUEST_ASSIGNED_TO_REGISTER,
            data: val
        });
    },

    getStatusList() {
        RSVP.all([
            GuestListApi.getStatusList(UserStore.getApiData()),
            GuestListApi.getDefaultStatus(UserStore.getApiData())
        ]).then(res => {
            AppDispatcher.dispatch({
                actionType: ActionTypes.STATUS_LIST_LOADED,
                data: { statuses: res[0].Data, default: res[1].Data },
            });
        });
        
    }
}

export default GuestListActions;



// WEBPACK FOOTER //
// ./ui_src/app/actions/GuestListActions.jsx